<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">{{
          isAT ? "Iniciativa" : isGov ? "Fases" : "Solução"
        }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
          <v-col>
            <ComboboxUsersMultipla
              :filter="payload"
              :label="'Gestor do Produto'"
            ></ComboboxUsersMultipla>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-group-solution-combobox
              :groupSolutionId="this.payload.grupoSolucaoId"
              :filter="payload"
              @changeGroupSolution="
                (grupoSolucaoId) => {
                  this.payload.grupoSolucaoId = grupoSolucaoId;
                }
              "
            ></app-group-solution-combobox>
          </v-col>
        </v-row>
        <v-row> </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row
          v-if="
            isFullAdmin || (config.verCustoPreco && groupsConfig.verCustoPreco)
          "
        >
          <v-col>
            <v-currency-field
              label="Custo"
              :prefix="currency"
              filled
              v-model="payload.custo"
            />
          </v-col>
          <v-col>
            <v-currency-field
              label="Preço"
              :prefix="currency"
              filled
              v-model="payload.preco"
            />
          </v-col>
        </v-row>

        <v-row
          v-if="
            isFullAdmin ||
            (config.verTipoSolucao && groupsConfig.verTipoSolucao)
          "
        >
          <v-col>
            <combobox-tipo-solucao :filter="payload"></combobox-tipo-solucao>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-radio-group v-model="payload.monitoramento">
              <v-radio
                v-for="monitoramento in tiposMonitoramento"
                :label="monitoramento.label"
                :value="monitoramento.value"
                :key="monitoramento.value"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              v-model="payload.dataInicioString"
              v-mask="'##/##/####'"
              label="Data de Início"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              v-model="payload.dataTerminoString"
              v-mask="'##/##/####'"
              label="Data de Término"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Número de visitas presenciais"
              name="numero-visitas-presenciais"
              type="number"
              required
              v-model="payload.visitasPresenciais"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Horas previstas de visitas presenciais"
              name="horas-previstas-visitas-presenciais"
              type="number"
              required
              v-model="payload.horasPrevistasVisitasPresenciais"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Número de trabalhos de escritório"
              name="numero-trabalhos-escritorio"
              type="number"
              required
              v-model="payload.trabalhosEscritorio"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.monitoramento == 2">
          <v-col>
            <v-text-field
              label="Horas previstas de trabalhos de escritório"
              name="horas-previstas-trabalhos-escritorio"
              type="number"
              required
              v-model="payload.horasPrevistasTrabalhosEscritorio"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-checkbox
              v-model="payload.naoComputaHoras"
              label="Não Computa Horas?"
              color="primary"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          tex
          @click="
            () => {
              dialog = false;
              this.payload = {};
            }
          "
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { solutionAPI } from "./SolutionAPI";
import { AppGroupSolutionCombobox } from "@/modules/group-solution";
import { mapActions, mapGetters } from "vuex";
import ComboboxTipoSolucao from "@/modules/tipoSolucao/components/Combobox";
import ComboboxUsersMultipla from "../../user/components/ComboboxUsersMultipla.vue";

export default {
  name: "AppModalInsertSolution",

  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    filter: { type: Object, required: false },
    groupSolutionId: "",
  },
  components: {
    AppGroupSolutionCombobox,
    ComboboxTipoSolucao,
    ComboboxUsersMultipla,
  },
  computed: {
    ...mapGetters(["loading", "isAT", "isFullAdmin", "isGov"]),
  },
  data() {
    return {
      currency: "R$",
      payload: {
        monitoramento: 1,
      },
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      dialog: false,
      tiposMonitoramento: [
        { label: "Tarefas", value: 1 },
        { label: "Visitas", value: 2 },
      ],
    };
  },
  mounted() {
    if (this.isAT || this.isGov) {
      this.tiposMonitoramento = [
        { label: "Atividades", value: 1 },
        { label: "Visitas", value: 2 },
      ];
    }
  },
  methods: {
    ...mapActions(["setLoading"]),

    onConfirm() {
      this.setLoading(true);
      if (this.edit === true) {
        solutionAPI
          .update(this.payload)
          .then((resp) => {
            this.payload = {};
            this.dialog = false;
            this.$emit("onSave");
          })
          .catch();
      } else {
        solutionAPI
          .create(this.payload)
          .then((resp) => {
            this.payload = {};
            this.dialog = false;
            this.$emit("onSave");
          })
          .catch();
      }
    },
  },
  watch: {
    object: {
      handler(val, oldVal) {
        this.payload = val;
        this.payload.usuarioIds = val.solucaoPrateleira.map(
          (item) => item.usuarioId
        );
      },
      deep: true,
    },
    dialog(val) {
      this.payload = {};

      if (this.object && this.edit === true) {
        console.log("this.object ", this.object);
        this.payload = this.object;
        this.payload.usuarioIds = this.object.solucaoPrateleira.map(
          (item) => item.usuarioId
        );
        this.$forceUpdate();
      }
    },
    groupSolutionId: function (group) {
      if (group) this.payload.grupoSolucaoId = group;
    },
  },
};
</script>
